import { PageBuilderButtonPropertiesModel } from "@de-trustleap/shared-models";
import { BaseWidget } from "./baseWidget";

export class ButtonWidget extends BaseWidget<PageBuilderButtonPropertiesModel> {
    private disableInlineStyles: boolean;

    constructor(properties: PageBuilderButtonPropertiesModel, disableInlineStyles = false) {
        super(properties);
        this.disableInlineStyles = disableInlineStyles;
    }

    render(): Promise<HTMLElement> {
        const button = this.createButtonElement();

        if (!this.disableInlineStyles) {
            this.applyButtonStyles(button);
            this.applyTextStyles(button);
            this.applyInteractions(button);
        } else {
            button.classList.add("default-button-style");
            button.textContent = this.properties.textProperties?.text?.trim() || "Kontaktieren Sie uns";
        }

        return Promise.resolve(button);
    }

    private createButtonElement(): HTMLButtonElement {
        const button = document.createElement("button");
        button.classList.add("button-widget");
        return button;
    }

    private applyButtonStyles(button: HTMLButtonElement): void {
        const width = this.properties.width ?? 120;
        const height = this.properties.height ?? 45;
        const borderRadius = this.properties.borderRadius ?? 5;
        const backgroundColor = this.formatColor(this.properties.backgroundColor, "#007BFF");

        this.applyStyles(button, {
            width: `${width}px`,
            height: `${height}px`,
            borderRadius: `${borderRadius}px`,
            backgroundColor,
            border: "none",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            transition: "opacity 0.2s ease, transform 0.1s ease",
            padding: `0 ${height / 4}px`
        });
    }

    private applyTextStyles(button: HTMLButtonElement): void {
        const textProps = this.properties.textProperties;
        if (!textProps) return;

        button.textContent = textProps.text?.trim() || "Button";
        this.applyStyles(button, {
            fontSize: `${textProps.fontSize ?? 16}px`,
            color: this.formatColor(textProps.color, "#FFFFFF"),
            fontFamily: textProps.fontFamily ?? "Arial, sans-serif"
        });
    }

    private applyInteractions(button: HTMLButtonElement): void {
        button.addEventListener("mouseover", () => (button.style.opacity = "0.9"));
        button.addEventListener("mouseout", () => (button.style.opacity = "1"));
        button.addEventListener("focus", () => (button.style.outline = "2px solid rgba(0, 0, 0, 0.3)"));
        button.addEventListener("blur", () => (button.style.outline = "none"));
        button.addEventListener("mousedown", () => (button.style.transform = "scale(0.98)"));
        button.addEventListener("mouseup", () => (button.style.transform = "scale(1)"));
    }
}
